import { findModuleExport } from '../webpack';
/** @component React Components */
export const Marquee = findModuleExport((e) => e?.toString && e.toString().includes('.Marquee') && e.toString().includes('--fade-length'));
